import { takeLatest, put, call } from 'redux-saga/effects';
import { SCORE_DEFINATION } from '../../../config'
import {
    ADD_CREDIT_LIMIT_MODEL,
    addCreditLimitModelResponse
} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from "../../../components/Utils/httpHelper";

export function* addCreditLimitModelRequest(action) {
    let requestURL = `${SCORE_DEFINATION}/creditlimit/add`;
    try {
        const result = yield call(request, requestURL, { data: action.data.creditLimitModelObj, method: 'POST', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(addCreditLimitModelResponse(result.data));
    } catch (err) {
        yield put(addCreditLimitModelResponse(err))
    }
}
export function* addCreditLimitModelSaga() {
    yield takeLatest(ADD_CREDIT_LIMIT_MODEL, addCreditLimitModelRequest);
}